<template>
  <div>
    <PageHeaderBanner>
      <template #title>
        <span>ATTOID新規登録</span>
      </template>
    </PageHeaderBanner>
    <div class="cmd00610-input-form q-gutter-y-md">
      <div class="row">
        <div class="col column">
          <label class="requier">構造式</label>
          <iframe
            id="sketch-iframe"
            ref="sketch-iframe"
            data-toolbars="reporting"
            title="marvin js editor"
            src="../../sketch/editorws.html"
            style="overflow: hidden; width:100%; height: 100% min-width: 500px; min-height: 350px; border: 1px solid darkgray"
          ></iframe>
        </div>
      </div>
    </div>
    <FormFooterBanner style="position: inherit">
      <template #button-area>
        <div class="cmd00610-button-area row">
          <q-btn
            color="grey-7"
            outline
            label="戻る"
            style="min-width: 120px; background: var(--q-white) !important"
            @click="pageBack()"
          />
          <div class="col q-gutter-x-xs flex justify-end">
            <q-btn color="primary" style="width: 150px" label="登録" @click="checkContents()" />
            <q-btn
              color="q-gray-3"
              outline
              style="width: 150px; background: var(--q-white) !important"
              icon="mdi-eraser"
              label="クリア"
              @click="clear()"
            />
          </div>
        </div>
      </template>
    </FormFooterBanner>
    <AlertDialog
      :display="openDialog"
      level="error"
      confirmation
      :title="dialogTittle"
      :text="dialogText"
      @complete="closeDialog"
      @close="openDialog = false"
    />
    <AlertDialog
      :display="registDialog"
      level="information"
      confirmation
      :title="dialogTittle"
      :text="dialogText"
      @complete="pageBack"
      @close="registDialog = false"
    />
    <AlertDialog
      :display="confirmationDialog"
      level="information"
      :title="'登録確認'"
      :text="['入力された内容で登録します。', 'よろしいですか？']"
      @confirm="registAttoID()"
      @close="confirmationDialog = false"
    />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import { clearMarvin, getMarvin } from '../../common/marvin-js';
import http from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

// ダイアログ表示判断
const openDialog = ref(false);

// 登録確認ダイアログ
const confirmationDialog = ref(false);

// 登録完了ダイアログ
const registDialog = ref(false);

// ダイアログタイトル
const dialogTittle = ref<string>('');

// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);

const router = useRouter();

// ダイアログ閉じる
const closeDialog = () => {
  openDialog.value = false;
};

// 戻るボタン押下時
const pageBack = () => {
  router.push({ name: 'attoId' });
};

// 構造式エディター未入力ダイアログ
const inputErrDialog = () => {
  openDialog.value = true;
  dialogTittle.value = '入力エラー';
  dialogText.value = ['構造式を入力してください。'];
};

// MarvinJs読み込み失敗ダイアログ
const readErrDialog = () => {
  openDialog.value = true;
  dialogTittle.value = 'MarvinJs読み込みエラー';
  dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
};

// 新規登録
const registAttoID = () => {
  confirmationDialog.value = false;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      // MarvinJs読み込み失敗ダイアログ
      readErrDialog();
    }
    // 構造式エディターに入力されていない場合
    if (structure === undefined) {
      // 構造式エディター未入力ダイアログ
      inputErrDialog();
    }
    // 構造式エディターに入力されている場合
    else {
      // Loading Start
      Loading.show();
      const formData = new FormData();
      // バックエンドに渡すデータに構造式を設定
      formData.append('structure', structure);

      // 新規登録
      http
        .post('/cmd006101/registAttoId', formData)
        .then((response) => {
          if (response.data.common.status === ResultStatusCode.ERROR) {
            if (
              response.data.common.detail_status === DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR
            ) {
              // 登録重複ダイアログ
              openDialog.value = true;
              dialogTittle.value = '登録重複エラー';
              dialogText.value = [response.data.common.message];
            } else if (response.data.common.detail_status === DetailResultStatusCode.INSERT_ERROR) {
              // 登録失敗ダイアログ
              openDialog.value = true;
              dialogTittle.value = '登録エラー';
              dialogText.value = [response.data.common.message];
              // その他のエラー
            } else {
              router.push({ name: 'error' });
            }
          } else {
            // 登録完了ダイアログ
            registDialog.value = true;
            dialogTittle.value = '登録完了';
            const text = response.data.common.message.split(' ');
            dialogText.value = text;
          }
        })
        .catch((err) => {
          if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
            // セッションタイムアウト
            router.push({ name: 'login', query: { timeout: 'timeout' } });
          } else {
            // その他エラー
            router.push({ name: 'error' });
          }
        })
        .finally(() => {
          // Loading End
          Loading.hide();
        });
    }
  });
};
const checkContents = () => {
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      // MarvinJs読み込み失敗ダイアログ
      readErrDialog();
    }
    // 構造式エディターに入力されていない場合
    if (structure === undefined) {
      // 構造式エディター未入力ダイアログ
      inputErrDialog();
    }
    // 構造式エディターに入力されている場合
    else {
      confirmationDialog.value = true;
    }
  });
};
// クリアボタン押下時新規登録入力内容クリア
const clear = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogTittle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
    }
  });
};
</script>
<style scoped>
.cmd00610-input-form {
  width: 80%;
  max-width: 500px;
  margin: 0 auto;
  margin-left: 12%;
}
.cmd00610-button-area {
  width: 80%;
  margin: 0 auto;
}
</style>
